import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { Button } from 'components/button';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import { UploadConsumer, UploadProptypes } from '@hotmart/club-files-ui';

import './FileUploading.scss';

@UploadConsumer()
export default class FileUploadingFailed extends PureComponent {
  static propTypes = {
    fileUpload: UploadProptypes.fileUpload,
    fileId: PropTypes.string,
    big: PropTypes.bool,
    id: PropTypes.string,
    children: PropTypes.node
  };

  get id() {
    return this.props.id || this.props.fileId;
  }

  render() {
    const { big, children } = this.props;
    const className = classNames('file__container file--failed', {
      'file__container--big': big
    });

    return (
      <div className={className}>
        <i className="icon icon-check-red-big" />

        {children && this.renderText()}

        <Button secondary outline onClick={this.tryAgain}>
          <I18n label="general.try_again" />
        </Button>
      </div>
    );
  }

  renderText() {
    const { children } = this.props;

    return (
      <label className="file--failed__description label__description">
        {children}
      </label>
    );
  }

  tryAgain = () => this.props.fileUpload.actions.replace(this.id);
}
